import { StyledSkeleton } from "./styled-components";
import { SkeletonProps } from "@kaltura/mediaspace-shared-styled";

export const MediaCardSkeleton = (props: SkeletonProps) => <StyledSkeleton {...props} variant={"rectangular"} />;
